import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-153dc540"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "footer-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon-arrow icon-prev"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "link-title"
}, "上一篇", -1));
const _hoisted_5 = {
  class: "set-like"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-like"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "link-title"
}, "下一篇", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon-arrow icon-next"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$data, _ctx$data4;
  const _component_t_button = _resolveComponent("t-button");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_t_button, {
    type: "",
    text: "",
    class: "link",
    disabled: !((_ctx$data = _ctx.data) !== null && _ctx$data !== void 0 && _ctx$data.last_id),
    onClick: _cache[0] || (_cache[0] = $event => {
      var _ctx$data2;
      return _ctx.handleToNewsDetail((_ctx$data2 = _ctx.data) === null || _ctx$data2 === void 0 ? void 0 : _ctx$data2.last_id);
    })
  }, {
    default: _withCtx(() => [_hoisted_3, _hoisted_4]),
    _: 1
  }, 8, ["disabled"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
    class: _normalizeClass(['set-like-btn', {
      'set-like-btn-after-click': _ctx.aboutLike.isLike || _ctx.alreadyLike
    }]),
    type: "button",
    onClick: _cache[1] || (_cache[1] = $event => {
      var _ctx$data3;
      return _ctx.setLikeClick(Number((_ctx$data3 = _ctx.data) === null || _ctx$data3 === void 0 ? void 0 : _ctx$data3.id));
    })
  }, [_hoisted_6, _createElementVNode("div", {
    class: _normalizeClass(['add-one', {
      'add-one-show': _ctx.aboutLike.isClick
    }])
  }, "+1", 2)], 2)]), _createVNode(_component_t_button, {
    type: "",
    text: "",
    class: "link",
    disabled: !((_ctx$data4 = _ctx.data) !== null && _ctx$data4 !== void 0 && _ctx$data4.next_id),
    onClick: _cache[2] || (_cache[2] = $event => {
      var _ctx$data5;
      return _ctx.handleToNewsDetail((_ctx$data5 = _ctx.data) === null || _ctx$data5 === void 0 ? void 0 : _ctx$data5.next_id);
    })
  }, {
    default: _withCtx(() => [_hoisted_7, _hoisted_8]),
    _: 1
  }, 8, ["disabled"])])]);
}